<template>
  <n-layout>
    <n-layout-header class="header">深圳市嘉玥禾科技有限公司</n-layout-header>
    <n-layout-content class="content" content-style="padding: 24px;">
      <n-flex vertical>
        <div class="title">让我们一起做些时髦又酷的东西吧！</div>
        <div class="sub-title">Let's make something trend and cool!</div>
        <n-flex class="ability-flex" justify="space-around" :size="32" :wrap="false">
          <AbilityItem image="home_design.webp" title="精美设计" text="Android、iOS、Web"/>
          <AbilityItem image="home_developer.webp" title="高效开发" text="移动应用、后端开发速度与品质"/>
          <AbilityItem image="home_data.webp" title="发布运营" text="应用数据统计、用户服务、快速分析"/>
        </n-flex>
        <div class="title">业务简介</div>
        <div class="sub-title">移动端：Android、iOS、微信小程序<br/>
          Web端：Vue、Flutter 框架的网页应用<br/>
          后端：Golang、Kotlin、Rust 开发的后台系统<br/>
          从应用开发直至部署、运营数据分析，为用户提供便捷高效的一站式服务。<br/>
        </div>
        <n-flex class="ability-flex" justify="space-around" :size="32" :wrap="false">
          <AbilityItem image="home_mobile.webp" title="移动应用开发" text="Android、iOS、微信小程序"/>
          <AbilityItem image="home_web.webp" title="网页应用开发" text="Vue、Flutter 框架开发"/>
          <AbilityItem image="home_backend.webp" title="服务的开发" text="Golang、Kotlin、Rutt、Python 语言开发"/>
        </n-flex>
        <div class="title">我们的产品</div>
        <AppShowItem icon="ps/icon.webp" name="PS美图AI修图"
                     text="一款好用智能的图片处理修图手机软件，超多强大的功能，一键处理照片美化"
                     download-url="https://www.pgyer.com/LgQdwoMZ"
                     :store-images="psStoreImages"/>
        <AppShowItem icon="aimage/icon.webp" name="AI魔术修图"
                     text="AI魔术修图，通过先进的人工智能技术，智能识别图像，自动优化色彩、亮度、对比度，让你的照片更具艺术感。"
                     download-url="https://www.pgyer.com/sOBEOZnd"
                     :store-images="aimageStoreImages"/>
        <AppShowItem icon="lr/icon.webp" name="LR图片映像调色"
                     text="LR图片映像调色，专业移动调色软件，智能AI辅助修图"
                     download-url="https://www.pgyer.com/EXCp6xHL"
                     :store-images="lrStoreImages"/>
        <AppShowItem icon="headshot/icon.png" name="最美映像证件照"
                     text="智能证件照制作，一键抠图，智能物体擦除软件"
                     download-url="https://www.pgyer.com/WyTnrber"
                     :store-images="headShotStoreImages"/>
        <AppShowItem icon="widgets/icon.webp" name="极简小组件"
                     text="轻巧实用的桌面小工具，让你的手机界面更简洁高效。"
                     download-url="https://www.pgyer.com/VUyTafpP"
                     :store-images="widgetsStoreImages"/>

        <AppShowItem icon="cook/icon.webp" name="做饭指南"
                     text="「做饭指南」—— 您的贴心烹饪向导，轻松制作美味佳肴"
                     download-url="https://www.pgyer.com/ZSnzmSj8"
                     :store-images="cookStoreImages"/>

        <AppShowItem icon="focus/icon.webp" name="番茄专注时钟"
                     text="专注，始于番茄。你的高效学习工作伴侣。"
                     download-url="https://www.pgyer.com/MAfBaDRS"
                     :store-images="focusStoreImages"/>
      </n-flex>
    </n-layout-content>
    <n-layout-footer class="footer">
      <n-flex vertical align="center">
        <n-flex align="center">
          <div>地址：深圳市福田区沙头街道天安社区泰然四路泰然科技园210栋七层7C343</div>
          <div>电话：+86 18128843153</div>
        </n-flex>
        <n-flex align="center">
          <n-flex align="center" @click="toPolice">
            <n-image width="16" height="16" src="home_police.webp"/>
            <div style="color: cornflowerblue">粤公网安备44030002006068号</div>
          </n-flex>
          <div @click="toBeian" style="color: cornflowerblue">粤ICP备2024309628号</div>
        </n-flex>
      </n-flex>
    </n-layout-footer>
  </n-layout>
</template>
<script>

import {NFlex, NImage, NLayout, NLayoutContent, NLayoutFooter, NLayoutHeader} from "naive-ui";
import AbilityItem from "@/components/AbilityItem.vue";
import AppShowItem from "@/components/AppShowItem.vue";

const psStoreImages = ['ps/1.jpg', 'ps/2.jpg', 'ps/3.jpg', 'ps/4.jpg', 'ps/5.jpg'];
const aimageStoreImages = ['aimage/1.webp', 'aimage/2.webp', 'aimage/3.webp', 'aimage/4.webp', 'aimage/5.webp'];
const lrStoreImages = ['lr/1.jpg', 'lr/2.jpg', 'lr/3.jpg', 'lr/4.jpg', 'lr/5.jpg'];
const headShotStoreImages = ['headshot/1.jpg', 'headshot/2.jpg', 'headshot/3.jpg', 'headshot/4.jpg', 'headshot/5.jpg'];
const widgetsStoreImages = ['widgets/1.jpg', 'widgets/2.jpg', 'widgets/3.jpg', 'widgets/4.jpg', 'widgets/5.jpg'];
const cookStoreImages = ['cook/1.jpg', 'cook/2.jpg', 'cook/3.jpg', 'cook/4.jpg', 'cook/5.jpg'];
const focusStoreImages = ['focus/1.jpg', 'focus/2.jpg', 'focus/3.jpg', 'focus/4.jpg', 'focus/5.jpg'];

export default {
  name: 'HomeView',
  components: {NImage, AppShowItem, NLayoutFooter, AbilityItem, NFlex, NLayoutContent, NLayoutHeader, NLayout},
  props: {},
  methods: {toBeian, toPolice},
  setup() {
    return {
      psStoreImages,
      aimageStoreImages,
      lrStoreImages,
      headShotStoreImages,
      widgetsStoreImages,
      cookStoreImages,
      focusStoreImages
    }
  }
}

function toBeian() {
  window.open("https://beian.miit.gov.cn/", '_blank')
}

function toPolice() {
  window.open("https://beian.mps.gov.cn/#/query/webSearch", '_blank')
}


</script>

<style>
.header {
  background: #18181c;
  padding: 24px;
  font-size: 18px;
  font-weight: bold;
}

.title {
  padding-top: 24px;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
}

.sub-title {
  text-align: center;
}

.ability-flex {
  padding-top: 16px;
}

.footer {
  padding-top: 16px;
  padding-bottom: 16px;
}

</style>
